(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["officina-kits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('officina-kit-filter')) {
  customElements.define('officina-kit-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = this.querySelector('.of-kits__tabs');
      if (!tabs) return;
      tabs.hidden = false;
      tabs.addEventListener('click', event => {
        const button = event.target.closest('[data-kit-filter]');
        if (!button) return;
        tabs.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-kit-category]').forEach(card => {
          card.hidden = button.dataset.kitFilter !== 'all' && card.dataset.kitCategory !== button.dataset.kitFilter;
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["officina-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('officina-scroll')) {
    customElements.define('officina-scroll', class extends HTMLElement {
      connectedCallback() {
        this.stories = Array.from(this.querySelectorAll('.of-scroll__story'));
        this.stage = this.querySelector('.of-scroll__stage');
        this.media = window.matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)');
        this.controller = new AbortController();
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.mode = () => {
          const header = document.querySelector('.theme__header');
          const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
          this.style.setProperty('--of-header', `${headerHeight}px`);
          this.classList.toggle('is-enhanced', this.media.matches);
          this.queue();
        };
        this.resize = () => this.mode();
        window.addEventListener('scroll', this.queue, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', this.resize, { passive: true, signal: this.controller.signal });
        this.media.addEventListener('change', this.mode);
        this.mode();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.mode(); });
      }
      update() {
        if (!this.classList.contains('is-enhanced')) return;
        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, rect.height - this.stage.offsetHeight);
        const headerHeight = parseFloat(this.style.getPropertyValue('--of-header')) || 0;
        const progress = Math.min(1, Math.max(0, (headerHeight - rect.top) / distance));
        this.style.setProperty('--of-progress', progress.toFixed(4));
        this.style.setProperty('--of-light', Math.sin(progress * Math.PI).toFixed(4));
        const active = Math.min(this.stories.length - 1, Math.floor(progress * this.stories.length));
        this.stories.forEach((story, index) => story.classList.toggle('is-active', index === active));
      }
      disconnectedCallback() {
        this.controller.abort();
        this.media.removeEventListener('change', this.mode);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
